<template>
  <div class="category-filter maxW" :class="{ 'oldFit': currentType === 1, 'customerFit': currentType === 4 }">
    <div class="first-cate">
      <!-- 一级分类 -->
      <div class="cate1-list" v-if="show_level >= 1">
        <div class="cate1-item" :class="{ 'active-item': item.id === current_cate_level1 }" v-for="(item,q) in cate_level1"
          :key="`${q}-${item.id}`" @click="changeCate(1, item.id)">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="other-cate" style="display: flex; justify-content:space-between">

      <div class="other-cate1">
        <!-- 二级分类 -->
        <div class="other-item other-cate2" v-if="show_level >= 2">
          <el-select v-model="current_cate_level2" :placeholder="$t('global.choose')"
            :popper-class="currentType === 1 ? 'oldFit' : 'customerFit'" @change="changeCate(2, current_cate_level2)"
            @visible-change="forceUpdateView">
            <el-option v-for="item in cate_level2" :key="`b-${item.id}`" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 三级分类 -->
        <div class="other-item other-cate3" v-if="show_level >= 3">
          <el-select v-model="current_cate_level3" :placeholder="$t('global.choose')"
            :popper-class="currentType === 1 ? 'oldFit' : 'customerFit'" @change="changeCate(3, current_cate_level3)"
            @visible-change="forceUpdateView">
            <el-option v-for="item in cate_level3" :key="`c-${item.id}`" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 四级分类 -->
        <div class="other-item other-cate4" v-if="show_level >= 4">
          <el-select v-model="current_cate_level4" :placeholder="$t('global.choose')"
            :popper-class="currentType === 1 ? 'oldFit' : 'customerFit'" @change="changeCate(4, current_cate_level4)"
            @visible-change="forceUpdateView">
            <el-option v-for="item in cate_level4" :key="`d-${item.id}`" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="other-item reset-btn" @click="reset(false)">
          <img src="@/assets/images/customer/reset.png" alt="reset">
          {{ $t('customer.reset') }}
        </div>
      </div>

      <div class="filter-nav">
        <el-button
          type="text"
          :class="[orderType == 'time' ? 'blueC' : '']"
          @click="toggle_order('time')"
        >
          {{ $t('homepage.time') }}<i class="el-icon-sort-down"></i>
        </el-button>
        <el-button
          type="text"
          :class="[orderType == 'click' ? 'blueC' : '']"
          @click="toggle_order('click')"
        >
          热门<i class="el-icon-sort-down"></i>
        </el-button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      show_level: null,
      orderType: "time",
      nativeCateData: [],

      cate_level1: [{ id: 0, name: this.$t("global.all") }],
      cate_level2: [{ id: 0, name: this.$t("global.all") }],
      cate_level3: [{ id: 0, name: this.$t("global.all") }],
      cate_level4: [{ id: 0, name: this.$t("global.all") }],

      current_cate_level1: 0,
      current_cate_level2: 0,
      current_cate_level3: 0,
      current_cate_level4: 0,
    };
  },
  created() {
    this.getCateLevel();
    this.getCateData();
  },
  watch: {
    "$store.state.customerCate"(nv) {
      if (!nv) {
        this.reset("watch");
      }
    },
  },
  computed: {
    currentType() {

      switch (this.$route.path) {
        case "/home/albumList":
          //  训练营
          return 5;
          break;
        case "/customer-home":
          //  客户培训路由
          return 4;
          break;
        case "/home/bigorderList":
          //  百万大单
          return 3;
          break;
        case "/home/leaderList":
          //  高层讲堂
          return 2;
          break;
        default:
          return 1;
          break;
      }
    },
  },
  methods: {
    toggle_order(type) {
      this.orderType = type;
      this.$emit("changeOrderType",this.orderType);
    },
    initCurrentCate() {
      let cateOptions = JSON.parse(sessionStorage.getItem("cateOptions"));
      let currentCate;
      if (cateOptions) {
        if (cateOptions.current_cate_level1) {
          currentCate = cateOptions.current_cate_level1;
          this.changeCate(1, cateOptions.current_cate_level1);
        }
        if (cateOptions.current_cate_level2) {
          currentCate = cateOptions.current_cate_level2;
          this.changeCate(2, cateOptions.current_cate_level2);
        }
        if (cateOptions.current_cate_level3) {
          currentCate = cateOptions.current_cate_level3;
          this.changeCate(3, cateOptions.current_cate_level3);
        }
        if (cateOptions.current_cate_level4) {
          currentCate = cateOptions.current_cate_level4;
          this.changeCate(4, cateOptions.current_cate_level4);
        }

        this.$store.commit("Change_Cate", currentCate);
        sessionStorage.removeItem("cateOptions");
      }
    },
    reset(isWatch) {

      if (!isWatch) {
        this.$emit("changeCateOption", {
          current_cate_level1: 0,
          current_cate_level2: 0,
          current_cate_level3: 0,
          current_cate_level4: 0,
        });
        return this.$store.commit("Change_Cate", 0);
      }

      this.cate_level1 = [{ id: 0, name: this.$t("global.all") }];
      this.cate_level2 = [{ id: 0, name: this.$t("global.all") }];
      this.cate_level3 = [{ id: 0, name: this.$t("global.all") }];
      this.cate_level4 = [{ id: 0, name: this.$t("global.all") }];
      this.current_cate_level1 = 0;
      this.current_cate_level2 = 0;
      this.current_cate_level3 = 0;
      this.current_cate_level4 = 0;

      this.getCateLevel();
      this.getCateData();
    },
    forceUpdateView() {
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    changeCate(level, id) {
      /* 这部分设计相当蠢，有时间可以重写 */
      this.$store.commit("Change_Cate", id);
      if (id === 0) {
        switch (level) {
          case 1:
            this.$store.commit("Change_Cate", 0);
            break;
          case 2:
            this.$store.commit("Change_Cate", this.current_cate_level1);
            break;
          case 3:
            this.$store.commit("Change_Cate", this.current_cate_level2);
            break;
          case 4:
            this.$store.commit("Change_Cate", this.current_cate_level3);
            break;
        }
      }
      // debugger;

      switch (level) {
        case 1:
          /* 先重置2、3、4级分类 */
          this.cate_level2 = [{ id: 0, name: this.$t("global.all") }];
          this.cate_level3 = [{ id: 0, name: this.$t("global.all") }];
          this.cate_level4 = [{ id: 0, name: this.$t("global.all") }];

          /* 再选中2、3、4级当前分类 */
          this.current_cate_level1 = id;
          this.current_cate_level2 = 0;
          this.current_cate_level3 = 0;
          this.current_cate_level4 = 0;

          /* 将下一级分类中的数据读取出来 */
          this.traversalNativeCate(this.nativeCateData, 2);
          break;

        case 2:
          this.current_cate_level2 = id;
          this.current_cate_level3 = 0;
          this.current_cate_level4 = 0;

          this.cate_level3 = [{ id: 0, name: this.$t("global.all") }];
          this.cate_level4 = [{ id: 0, name: this.$t("global.all") }];

          this.traversalNativeCate(this.nativeCateData, 3);
          break;
        case 3:
          this.current_cate_level3 = id;
          this.current_cate_level4 = 0;

          this.cate_level4 = [{ id: 0, name: this.$t("global.all") }];

          this.traversalNativeCate(this.nativeCateData, 4);
          break;
        case 4:
          this.current_cate_level4 = id;
          break;
      }
      this.$emit("changeCateOption", {
        current_cate_level1: this.current_cate_level1,
        current_cate_level2: this.current_cate_level2,
        current_cate_level3: this.current_cate_level3,
        current_cate_level4: this.current_cate_level4,
      });
    },
    /**
     * 此函数用于将原始分类数据整理出页面所需的分类数据
     * @param {[]} cate 接口返回的原始分类数据
     * @param {number} level  需要抽取的分类等级
     */
    traversalNativeCate(cate, level) {
      if (cate.length) {
        for (const item of cate) {
          switch (level) {
            case 1:
              if (item.level === 1) {
                if(item.name === '默认分类'){
                  item.id = -1
                }
                this.cate_level1.push(item);
              }
              break;

            case 2:
              if (
                this.current_cate_level1 !== 0 &&
                item.id === this.current_cate_level1
              ) {
                this.cate_level2 = [
                  { id: 0, name: this.$t("global.all") },
                  ...item.children,
                ];
              }
              break;

            case 3:
              if (
                this.current_cate_level2 !== 0 &&
                item.id === this.current_cate_level2
              ) {
                this.cate_level3 = [
                  { id: 0, name: this.$t("global.all") },
                  ...item.children,
                ];
              }
              break;

            case 4:
              if (
                this.current_cate_level3 !== 0 &&
                item.id === this.current_cate_level3
              ) {
                this.cate_level4 = [
                  { id: 0, name: this.$t("global.all") },
                  ...item.children,
                ];
              }
              break;
          }
          if (item.children && item.children.length) {
            this.traversalNativeCate(item.children, level);
          }
        }

      }
      this.$forceUpdate();

    },
    getCateLevel() {

      let success = (res) => {
        this.show_level = res.data.show_level;
      };
      let params = {
        type: this.currentType,
      };
  
      this.$ajax.get("/api/video/cate_show", { params, func: { success } });
    },
    getCateData() {
      let success = (res) => {
        this.nativeCateData = res.data;
        this.traversalNativeCate(this.nativeCateData, 1);
        this.initCurrentCate();
      };
      let params = {
        status: 1,
        level: 4,
        type: this.currentType,
      };
      this.$ajax.get("/api/video/video_cate", { params, func: { success } });
    },
  },
};
</script>

<style scoped lang='scss'>
.category-filter {
  user-select: none;

  .first-cate {
    background-color: #fff;
    padding: 0.5rem 2rem;
    // box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);
    display: flex;

    .label {
      font-size: 1.2rem;
      font-weight: 700;
      color: #333333;
    }

    .cate1-list {
      display: flex;
      flex-wrap: wrap;
      line-height: 3rem;

      .cate1-item {
        font-size: 1.2rem;
        margin-right: 4rem;
        color: #999999;

        &:hover {
          cursor: pointer;
          color: #e62125;
          opacity: 0.8;
        }
      }

      .cate-item:nth-child(1) {
        margin-left: 0;
      }

      .active-item {
        color: #e62125;
      }
    }
  }

  .other-cate1 {
    display: flex;
  }
  .other-cate {
    margin-top: 2rem;
    display: flex;

    .other-item {
      margin-right: 2rem;
      width: 200px;
      height: 3.2rem;
      line-height: 3.2rem;
      font-size: 1.2rem;
      background-color: #fff;
      // box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);
      :deep(.el-input__inner) {
        border: none;
        border-radius: 0px;
       
        height: 3.2rem;
        line-height: 3.2rem;
        font-size: 1.2rem;
      }
    }

    .reset-btn {
      width: 80px;
      // box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);
      display: flex;
      justify-content: center;
      align-items: center;
      color: #606266;

      img {
        width: 1.2rem;
        height: 1.2rem;
        margin-right: 0.5rem;
      }

      &:hover {
        cursor: pointer;
      }

      &:active {
        transform: translateX(1px) translateY(1px);
      }
    }
  }
}

.customerFit {
  .first-cate {
    .cate1-list {
      .cate1-item {
        font-size: 1.2rem;
        margin-right: 4rem;
        color: #999999;

        &:hover {
          cursor: pointer;
          color: #e62125;
          opacity: 0.8;
        }
      }

      .active-item {
        color: #e62125;
      }
    }
  }
}

.oldFit {
  .first-cate {
    .cate1-list {
      .cate1-item {
        font-size: 1.2rem;
        margin-right: 4rem;
        color: #999999;

        &:hover {
          cursor: pointer;
          color: #E62126;
          opacity: 0.8;
        }
      }

      .active-item {
        color: #E62126;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.customerFit {
  :deep(.el-select .el-input .el-select__caret) {
    font-size: 1.5rem;
  }

  :deep(.el-select-dropdown) {
    user-select: none;

    .el-select-dropdown__item {
      margin-top: 1px;
    }

    .el-select-dropdown__item.hover {
      background-color: #e62125;
    }

    .el-select-dropdown__item.selected {
      background-color: #e62125;
      color: #fff;
    }
  }
}

.oldFit {
  :deep(.el-select .el-input .el-select__caret) {
    font-size: 1.5rem;
  }

  :deep(.el-select-dropdown ){
    user-select: none;

    .el-select-dropdown__item {
      margin-top: 1px;
    }

    .el-select-dropdown__item.hover {
      background-color: #E62126;
    }
  }

  .el-select-dropdown__item.selected {
    background-color: #E62126 !important;
    color: #fff !important;
  }
}


.filter-nav {
  display: inline-block;
  padding: 4px;
  margin-bottom: 20px;
  background: #fff;
  // box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);

  .el-button {
    line-height: 24px;
    font-size: 14px;
    color: #000;
    color: #727272;
    background: #fff;
    padding: 3px 5px;
    text-align: center;
  }

  .el-icon-sort-down {
    margin-left: 5px;
  }

  .cut {
    margin: 0 20px;
    color: #d2d2d2;
  }

  .blueC {
    color: #338efc;
    color: #fff;
    border-radius: 2px;
    background: #E62126;
  }

  .el-button + .el-button {
    margin-left: 5px;
  }
}

</style>
